















































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import EditableTree from '@root/components/data-layout/editable-tree.vue';
import AddEditModal from './components/add-edit-modal.vue';
import PlateInput from '@/components/plate-input/index.vue';
import moment from 'moment';
import toTree from '@root/utils/to-tree';

@Component({
  components: { EditableTree, AddEditModal, PlateInput }
})
export default class AdministrativeDivisionList extends Mixins(TableMixin, TableWidthMixin) {
  // 弹窗控制
  modalVisible: boolean = false;
  isEdit: boolean = false;
  modalData: any = [];

  // 表格控制
  tableData: any[] = [
    {
      parkName: '一二三四五六七八九十一'
    }
  ]; // 表数据

  searchValue = ''; // 查询条件内容值
  searchType = 'name'; // 查询条件下拉框当前值
  // 查询条件下拉框选项
  get searchOption() {
    return [
      {
        value: 'name',
        label: '行政区划名称'
      },
      {
        value: 'code',
        label: '编号'
      }
    ];
  }

  // 左右栏配置
  get flexColumns() {
    return [
      {
        id: 'tree',
        hiddenHeader: true,
        width: '300px',
        padding: '20px'
      },
      {
        id: 'table',
        title: '机构列表',
        padding: '20px 0 20px 20px'
      }
    ];
  }

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '编号',
        dataIndex: 'parkName',
        width: 140
      },
      {
        title: '行政区划名称',
        dataIndex: 'parkName1',
        width: 200
      },
      {
        title: '上级行政区划名称',
        dataIndex: 'parkName2',
        width: 200
      },
      {
        title: '车牌号首字符',
        dataIndex: 'parkName3',
        width: 200
      }
    ];
  }

  // 树状图列表
  treeSource = [
    {
      title: '供配电下的一级系统',
      key: '0-0',
      children: [
        {
          title: '高压配电系统',
          key: '0-0-0',
          children: [
            {
              title: '低压配电系统',
              key: '0-0-0-0',
              children: [
                {
                  title: '末级产品给排水系统',
                  key: '0-0-0-0-0'
                },
                {
                  title: '末级产品给排水',
                  key: '0-0-0-0-1'
                },
                {
                  title: '末级产品给水',
                  key: '0-0-0-0-2'
                }
              ]
            },
            {
              title: '水箱',
              key: '0-0-0-1'
            },
            {
              title: '给水稳压泵',
              key: '0-0-0-2'
            }
          ]
        },
        {
          title: '高压配电系统末级产品',
          key: '0-0-1'
        },
        {
          title: '高压配电系统末级产品2',
          key: '0-0-2'
        }
      ]
    },
    {
      title: '',
      key: '0-1'
    }
  ];

  // method
  mounted() {
    // const treeList = [
    // { parent_id: '', name: '0', id: '0', type: 1 },
    // { parent_id: '0', name: '0-1', id: '0-1', type: 1 },
    // { parent_id: '0', name: '0-2', id: '0-2', type: 1 },
    // { parent_id: '0-2', name: '0-2-1', id: '0-2-1', type: 1 },
    // { parent_id: '0-2', name: '0-2-2', id: '0-2-2', type: 1 },
    // ]
    // this.treeSource = toTree(treeList)
  }

  // 表格查询过滤
  handleSearch() {}

  // 树新增
  onTreeAdd(key: string, item: any) {}
  // 树编辑
  onTreeEdit(key: string, item: any) {}
  // 树删除
  onTreeDelete(key: string, item: any) {}

  // 岗位设置
  onTableRoleSet() {}
  // 表格行编辑
  onTableEdit() {}
  // 表格行删除
  onTableDelete() {}

  // 创建行政区划
  showAddModal() {
    this.isEdit = false;
    this.modalVisible = true;
  }
  // 编辑行政区划
  showEditModal(record: any) {
    this.isEdit = true;
    this.modalData = record;
    this.modalVisible = true;
  }
  // 弹窗取消
  handleModalCancel() {
    this.modalVisible = false;
  }
  // 弹窗保存
  handleModalCreate() {
    this.modalVisible = false;
    this.fetchTableData(true);
  }
}
